import { reactive } from 'sitekit-extensions'
import createTimeline from '../util/async/timelineFactory'

export default function woocommerceCheckoutFormWidget(Site, $) {
  Site.widget('woocommerce-checkout-form', {
    use: [reactive()],
    _create() {
      console.log('runs')
      this.inputs = this.element.find('[name]')
      this.state = {
        form: this.serializeForm(this.inputs),
      }

      this.resetApiTimeline = createTimeline()
    },
    react() {
      this.changed('form', (prevState) => {
        if (empty(prevState)) {
        } else {
          this.callAPI()
        }
      })
    },
    serializeForm($inputs) {
      let result = {}

      $inputs.not(`[type="radio"]`).each((i, el) => {
        result[$(el).attr('name')] = $(el).val()
      })

      $inputs.filter(`[type="radio"]:checked`).each((i, el) => {
        result[$(el).attr('name')] = $(el).val()
      })

      return result
    },
    async callAPI() {
      // Any pending waitFor's will never resolve once resetApiTimeline is called
      const waitFor = this.resetApiTimeline()

      await waitFor(2000)

      const response = await Site.callAPI('woocommerce/add-cart-data', {
        SH_CUSTOMER_DATA: this.state.form,
      })
    },
  })
}

function empty(obj) {
  return !Object.keys(obj).length
}
